import type { Tenant } from '@pflegenavi/frontend/tenant';
import type { AuthenticationContext } from '@pflegenavi/frontend/authentication';
import type { Api } from '@pflegenavi/shared-frontend/platform';
import { get, getApiBaseUrl } from '@pflegenavi/shared-frontend/platform';
import type {
  IReceiptsByStatus,
  ResidentSummaryDto,
} from '@pflegenavi/shared/api';
import { endpoints } from '@pflegenavi/shared/api';

export interface IAnalyticsApi extends Api {
  getByResidentId(data: {
    params: { residentId: string; month?: Date };
  }): Promise<IReceiptsByStatus>;

  getResidentSummary(data: {
    params: { residentId: string; familyMemberId?: string | null };
  }): Promise<ResidentSummaryDto>;
}

export class AnalyticsApi implements IAnalyticsApi {
  getByResidentId: IAnalyticsApi['getByResidentId'];
  getResidentSummary: IAnalyticsApi['getResidentSummary'];

  constructor(
    tenantId: Tenant,
    public authContext: AuthenticationContext,
    apiUrl?: string
  ) {
    const baseUrl = getApiBaseUrl(tenantId, apiUrl);

    this.getByResidentId = get({
      authContext: authContext,
      url: ({ residentId, month }) => {
        const queryParams = new URLSearchParams();
        if (month) {
          queryParams.set('month', month.toISOString());
        }

        return `${baseUrl}/${
          endpoints.analytics
        }/${endpoints.analyticsGetByResident.replace(
          ':residentId',
          residentId
        )}?${queryParams.toString()}`;
      },
    });

    this.getResidentSummary = get({
      authContext: authContext,
      url: ({ residentId, familyMemberId }) => {
        const queryParams = new URLSearchParams();

        if (familyMemberId !== undefined) {
          queryParams.set(
            'familyMemberId',
            familyMemberId === null ? 'null' : familyMemberId
          );
        }

        return `${baseUrl}/${
          endpoints.analytics
        }/${endpoints.analyticsGetResidentSummary.replace(
          ':residentId',
          residentId
        )}?${queryParams.toString()}`;
      },
    });
  }
}
